import React, { useState } from 'react';
import { Box, Card, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import imgMenuExample from './menu-example.jpg';
import LanguageSelect from '../../../../components/shared/LanguageSelect';
import CusLink from '../../../../components/material-ui/CusLink';
import CusInput from '../../../../components/material-ui/CusInput';
import CusButton from '../../../../components/material-ui/CusButton';
import { API_CASINO } from '../../../../api/casino';
import useToast from '../../../../hooks/useToast';

export default function TgMenuBot({ casinoId }) {
  const { t } = useTranslation();
  const { successToast, errorToast } = useToast();
  const [lang, setLang] = useState('all');
  const [textAreaValue, setTextAreaValue] = useState('');

  const onFillDefault = () => {
    if (lang == 'ru') {
      setTextAreaValue(
        `start-Запустить Бот 
menu-Меню
deposit-Пополнить баланс +
withdraw-Вывод с баланса -
profile-Профиль
lang-Язык`
      );
      return;
    }

    setTextAreaValue(
      `start-Start Bot
menu-Menu
deposit-Deposit +
withdraw-Withdrawals -
profile-Profile
lang-Language`
    );
    return;
  };

  const onRunClick = () => {
    const commands = textAreaValue.split('\n');

    const param = { casinoId, commands };
    if (lang !== 'all') param.lang = lang;

    API_CASINO.setTgMenuNames(param)
      .then((e) => {
        console.log(e);
        const reply = e.data.reply;
        const isReplyOk = reply.ok || e.data.ok;

        if (isReplyOk) {
          successToast('Information updated successfully');
        } else {
          errorToast(reply?.description || t('An error occurred'));
        }
      })
      .catch(console.error);
  };

  return (
    <Stack gap={1}>
      <Typography variant="h5">{t('Menu in the bot')}</Typography>
      <Stack gap={1} direction={'row'} alignItems={'center'}>
        <Stack flex={1} gap={1}>
          <LanguageSelect
            isAllLanguages
            value={lang}
            setValue={setLang}
            label={'Lang'}
            isRow
            toolTipText='If you select "For all languages", the menu will be shown to all TG users for whose language there are no commands installed.'
          />
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Typography>{t('Menu')}</Typography>
            <CusLink text="Fill as default" linkComponent="button" onClick={onFillDefault} />
          </Stack>

          <CusInput
            rows={7}
            value={textAreaValue}
            onChange={(e) => setTextAreaValue(e.target.value)}
          />
          <CusButton onClick={onRunClick} text="Execute" />
        </Stack>
        <Box width={250}>
          <img src={imgMenuExample} style={{ maxWidth: '100%' }} />
        </Box>
      </Stack>
    </Stack>
  );
}
